<div class="containerView top-1 3xl:relative 3xl:left-3 w-[1000px]"
  [ngClass]="{
    'relative left-0 3xl:left-[11px] pr-0 2xl:pr-13 3xl:pr-0 w-full overflow-x-hidden 3xl:w-[1500px] mx-auto flex items-start': currentPage === 'Nazione'
  }"
>

   <!--<ng-container *ngIf="nameFarmaco && (currentPage === 'Nazione' || currentPage === 'Regione')">-->
        <!-- <h1 
              *ngIf="makeItVisible"
              class="text-[#098492] text-[0.85em] 2xl:text-[0.91em] 3xl:text-[0.97em] 4xl:text-[1.1em] ">{{nameFarmaco}}</h1>
   -->
          <div
           *ngIf="makeItVisible"
            class="flex-row gap-1.5 text-gray-800 font-medium inline-flex items-center pl-1 pr-1.5 py-0.5 rounded-lg">
          <!--  <svg width="16" height="16" 
            class="w-[14px] h-[14px] 2xl:w-[16px] 2xl:h-[16px] 3xl:w-[18px] 3xl:h-[18px] 4xl:w-[20px] 4xl:h-[20px]"
            viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.0779 1.92188C9.62718 1.47138 9.01599 1.21832 8.37871 1.21832C7.74144 1.21832 7.13024 1.47138 6.67949 1.92188L1.92168 6.67969C1.47102 7.13029 1.21782 7.74145 1.21777 8.37874C1.21773 9.01603 1.47085 9.62723 1.92145 10.0779C2.37205 10.5286 2.98321 10.7818 3.6205 10.7818C4.25779 10.7818 4.86899 10.5287 5.31965 10.0781L10.0779 5.32031C10.5281 4.86938 10.7809 4.25825 10.7809 3.62109C10.7809 2.98393 10.5281 2.37281 10.0779 1.92188ZM4.92168 9.67969C4.5743 10.013 4.11011 10.197 3.62869 10.192C3.14727 10.1871 2.68694 9.99373 2.34644 9.65335C2.00595 9.31298 1.81239 8.85272 1.8073 8.3713C1.8022 7.88988 1.98597 7.42563 2.31918 7.07813L4.49981 4.89797L7.10231 7.5L4.92168 9.67969ZM9.68043 4.92188L7.49981 7.10203L4.89731 4.5L7.07793 2.32031C7.42532 1.98697 7.8895 1.80304 8.37092 1.80796C8.85235 1.81289 9.31267 2.00627 9.65317 2.34665C9.99367 2.68702 10.1872 3.14728 10.1923 3.6287C10.1974 4.11012 10.0136 4.57437 9.68043 4.92188ZM8.82449 3.92625C8.87716 3.97899 8.90675 4.05047 8.90675 4.125C8.90675 4.19953 8.87716 4.27102 8.82449 4.32375L7.69949 5.44875C7.64664 5.50082 7.57534 5.52989 7.50115 5.52963C7.42695 5.52938 7.35586 5.49981 7.30337 5.44738C7.25087 5.39494 7.22122 5.32389 7.22088 5.24969C7.22053 5.1755 7.24952 5.10417 7.30153 5.05125L8.42653 3.92625C8.45265 3.9001 8.48366 3.87936 8.51781 3.8652C8.55195 3.85105 8.58855 3.84376 8.62551 3.84376C8.66247 3.84376 8.69907 3.85105 8.73321 3.8652C8.76735 3.87936 8.79837 3.9001 8.82449 3.92625Z" fill="#0A778A"/>
</svg> -->
 <h1 class="text-[#0A768A] text-[0.7rem] xl:text-[0.8rem] 2xl:text-[0.9rem] 3xl:text-[1rem] 4xl:text-[1.rem]"

>{{nameFarmaco}}</h1>

          </div>

          
            <!-- </ng-container> -->      
</div>
   <!-- <div class="border border-[#d1d5db] h-11 rounded-md bg-white shadow-sm">
        <div class="breadcrumb flex items-center h-full px-6 text-gray-600 text-[0.9em] font-semibold gap-2 py-2.5">
            <span>Territorial Access</span>
            <ng-container *ngIf="nameFarmaco && (currentPage === 'Nazione' || currentPage === 'Regione')">
              <span class="text-3xl font-bold text-[#9b9b9b] mx-2.5 mb-1.5">›</span>
              <h1 
              (click)="navigateToFarmaco()"
              class="text-[#098492] hover:text-dimot-1 cursor-pointer">{{nameFarmaco}}</h1>
            </ng-container>
            <span class="text-3xl font-bold text-[#9b9b9b] mx-2.5 mb-1.5">›</span>
            <span *ngIf="currentPage !== 'Settings'">{{currentPage}}</span>
            <span *ngIf="currentPage === 'Settings'">Impostazioni</span>
        </div>
    </div>
</div>-->



<!-- usefull for the future -->

<!--<div class="header-container flex">
    <div class="breadcrumb flex items-center h-full justify-center pl-5 text-[#171e47] text-sm font-semibold gap-2">
      <span class="firstCrumb text-sm mt-1">TERRITORIAL ACCESS</span>
      <span class="divisor text-2xl mx-2 mb-1">›</span>
      <span class="text-sm">Lista dei Farmaci</span>
     <span class="farmacoButton cursor-pointer transition-colors duration-200 ease-in-out text-[#098492] hover:text-[#1eb4c4]" (click)="goToNational('Italy'); openModalMedicine(true);">
        {{ businessName }}
      </span>
      <span class="divisor text-2xl mx-2 mb-1">›</span>
      <span *ngIf="!nationalOpen" class="text-sm">{{ region }}</span>
      <span *ngIf="nationalOpen" class="text-sm">Dashboard Nazionale</span> 
    </div>
  </div>--> 
  